import React from "react";
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class UpdateInvoiceForm extends React.Component {
    constructor(props) {
        super(props);
      }
  state = {
    invoice: {  
      businessName: "",//show
      currentBalance: "", //show
      amountDue:"",//show
      dueDate:"",//show
      amountPaid:"",//insert
      status:"",//insert
      datePaid:"",//insert
      remarks:"",
      subscriptionInvoiceId: ""
    },
    status: [],
    errors: {}
  };

  schema = Joi.object().keys({
    subscriptionInvoiceId: Joi.number(),
    businessName: Joi.any(),
    currentBalance:Joi.any(),
    amountDue :Joi.any(),
    dueDate: Joi.any(),
    amountPaid:Joi.number()
    .required()
    .error(errors => {
      return {
        message: " enter amount paid "
      };
    }),
    datePaid:Joi.date()
    .required()
    .error(errors => {
      return {
        message: "Select paid Date"
      };
    }),
    remarks:Joi.string()
    .required()
    .error(errors => {
      return {
        message: "Select remarks"
      };
    }),
    status:Joi.number()
      .required()
      .error(errors => {
        return {
          message: "Select status"
        };
      }),
    
  });

  componentDidMount() {
    this.getStatus();  
    this.getUser();
  }

  async getStatus(){
    try {
      let { data } = await httpClient.get("/subscriptions/invoice_status");
      this.setState({ status: data["response"] });
    } catch (error) {
      this.setState({ status: [] });
    }
  }

  async getUser() {
    try {
      let {subscriptionInvoiceId} = this.props;
      console.log("my subscriptionInvoiceId",subscriptionInvoiceId);
      let { data } = await httpClient.get(`/subscriptions/${subscriptionInvoiceId}`);
     console.log("invoice data",data);
      let invoice = data["response"][0][0];
     // console.log("invoice 111 data",invoice);
      let info = {
        subscriptionInvoiceId: subscriptionInvoiceId,
        businessName: invoice["business_name"],
        currentBalance: invoice["current_balance"],
        amountDue: invoice["amount_due"],//show
        dueDate: invoice["due_date"],//show
        amountPaid:invoice["amount_paid"],//insert
        status: invoice["subscription_invoice_status_id"],
        datePaid : invoice["date_paid"],
      };
      //console.log("Info data",info);  
      
      this.setState({invoice: info });
    } catch (error) {
      let invoice = {
      businessName:"",
      currentBalance:"",
      amountDue:"",//show
      dueDate: "",//show
      datePaid:"",
      amountPaid:"",//insert
      status: "",
      subscriptionInvoiceId: "",
      };
      this.setState({invoice:invoice});
    }    
  }

  reset = () => {
    let invoice = {
        businessName: "",//show
        currentBalance: "", //show
        amountDue:"",//show
        dueDate:"",//show
        amountPaid:"",//insert
        status:"",//insert
        datePaid:"",//insert
        remarks:"",
    };

    let errors = {};
    this.setState({ invoice, errors });
  };

 
  validation() {
   // console.log("ERRORS DATA",this.state.invoice);
    let { error } = Joi.validate(this.state.invoice, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // handle change
  handleChange = event => {
    let value = event.target.value;
    let invoice = { ...this.state.invoice };
    invoice[event.target.name] = value;
    this.setState({invoice});
    console.log("HANDLE CHANGE",invoice);
  };
  handledDatePaid = date => {
    let invoice = { ...this.state.invoice };
    
    invoice.datePaid = date;
    this.setState({
      invoice
    });
    //console.log("MY DUE DATE",invoice);
  };
  // on submit
  handleSubmit = async event => {
    event.preventDefault();
    // validation
    let errors = this.validation();

    if (errors) {
      console.log(errors);

      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let invoice = this.state.invoice;
   // console.log("my invoice data",invoice);
    try {
  console.log("Update request Send;");
  //console.log("my invoice data",invoice);
  const InvoiceData={
   subscriptionInvoiceId : invoice.subscriptionInvoiceId,
   status : invoice.status,
   amountPaid : invoice.amountPaid,
   remarks : invoice.remarks,
   datePaid : invoice.datePaid
 }
 console.log("API Update Invoice DATA",InvoiceData);
      var { status, data } =await httpClient.put("/subscriptions",InvoiceData);
      console.log(data);
      if (status === 200) {
        // show verification modal
        toast.success("دی گئی معلومات محفوظ کر دی گئی ہیں", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.reset();
        this.props.toggle();
        this.props.getUsers();
        //this.props.fetchUses();
        //window.location.reload();
      }
      //window.location.reload();
    } catch (error) {
      // error occur

      console.log("ERORS",error);
      
      toast.error("Oops something went wrong!!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
   
     }
  };
  
  render() {
     let {invoice,status,errors } = this.state;
    //console.log("MY invoice DATA 1111",invoice);
    const statusList = status.map(s => (
        <option key={s["subscription_invoice_status_id"]} value={s["subscription_invoice_status_id"]}>
          {s["subscription_invoice_status_name"].toUpperCase()}
        </option>
      ));
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle} size={"lg"}>
          <ModalHeader
            className="bg-info text-light"
            toggle={this.props.toggle}
          >
            update Invoice
          </ModalHeader>
          <ModalBody>
            <Form className="row">
            <FormGroup className="col-6 formGroup">
                <Label for="status">Invoice Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={invoice.status}
                  id="status"
                  invalid={Boolean(errors["status"])}
                  onChange={this.handleChange}
                  
                >
                  <option value="">Select Status</option>
                  {statusList}
                </Input>
                
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="businessName">businessName</Label>
                <Input
                  type="text"
                  name="businessName"
                  id="businessName"
                  placeholder="businessName"
                  value={invoice["businessName"]}
                
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="current Balance">current Balance</Label>
                <Input
                  type="text"
                  name="currentBalance"
                  id="currentBalance"
                  value={invoice["currentBalance"]}
                  placeholder="currentBalance"
                  
                 disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="amountDue">Amount Due</Label>
                <Input
                  type="text"
                  name="amountDue"
                  id="amountDue"            
                  value={invoice["amountDue"]}
                  placeholder=" Enter amount Due"
                 
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="dueDate">due date</Label>
                <Input
                  type="text"
                  name="dueDate"
                  id="dueDate"
                  value={
                    moment(invoice["dueDate"]).format('DD-MM-YYYY')
                  }
                  placeholder="dueDate"
                
                   disabled
                />          
              </FormGroup>
              <FormGroup className="col-6">
        <Label for="datePaid">
        Date paid
        </Label>
        <br/>
        <DatePicker
         // style={{ dipslay: "block" }}
          dateFormat="dd/MM/yyyy"
          value={
            moment(invoice["datePaid"]).format('DD-MM-YYYY')
          }
          placeholderText="Enter date Paid"
         // selected={invoice.datePaid}
          invalid={Boolean(errors["datePaid"])}
          onChange={this.handledDatePaid}
        />  
        </FormGroup>
              <FormGroup className="col-6 formGroup">
                <Label for="amountPaid">Amount paid</Label>
                <Input
                  type="text"
                  name="amountPaid"
                  id="amountPaid"            
                  value={invoice["amountPaid"]}
                  placeholder=" Enter amount paid"
                  invalid={Boolean(errors["amountPaid"])}
                  onChange={this.handleChange}
                  
                  //disabled
                />
              </FormGroup>
              
        <FormGroup className="col-6 formGroup">
                <Label for="remarks">remarks</Label>
                <Input
                  type="text"
                  name="remarks"
                  id="remarks"
                  placeholder="enter remarks"
                  value={invoice["remarks"]}
                  invalid={Boolean(errors["remarks"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              {/* 
              
              <FormGroup className="col-6">
                <Label for="cityId">city Name</Label>
                <Input
                  type="text"
                  name="cityName"
                  id="cityName"
                  value={invoice["cityName"]}
                  placeholder="cityName"
                  
                  
                   disabled
                />
              </FormGroup>
              
            
              <FormGroup className="col-6">
                <Label for="adjustmentAmount">adjustment Amount</Label>
                <Input
                  type="text"
                  name="adjustmentAmount"
                  id="adjustmentAmount"
                  value={invoice["adjustmentAmount"]}
                  placeholder=" Enter Adjustment Amount"
                  invalid={Boolean(errors["adjustmentAmount"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="itemName">Item Name</Label>
                <Input
                  type="text"
                  name="itemName"
                  id="itemName"           
                  value={invoice["itemName"]}
                  placeholder=" Enter Item Name"
                  invalid={Boolean(errors["itemName"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
            
              <FormGroup className="col-6">
                <Label for="discount">Discount</Label>
                <Input
                  type="text"
                  name="discount"
                  id="discount"              
                  value={invoice["discount"]}
                  placeholder=" Enter Discount"
                  invalid={Boolean(errors["discount"])}
                  onChange={this.handleChange}
                />
              </FormGroup> */}
            
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.handleSubmit}>
             update Invoice
            </Button>
            <Button color="danger" onClick={this.props.toggle}>
            منسوخ کریں
            </Button>
          </ModalFooter>
        </Modal>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default UpdateInvoiceForm;